let state = {
    Sections : [
        [
            {
                id: "intracanal",
                h1: "(внутриканальные)",
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw10000-f",
                className:"right",
                title: "HA-FW10000",
                text: [
                    {li:`Модель JVC HA-FW10000, выпущенная к 10-летнему юбилею фирменной линейки WOOD, занимает топовую позицию среди внутриканальных наушников JVC.`},
                    {li:` Корпуса наушников изготовлены из японского клена (Acer palmatum, «Клён дланевидный»), а в качестве излучателей здесь используются 11-миллиметровые широкополосные драйверы с гибридными диффузорами, включающими в себя  деревянный купол толщиной всего в 50 микрон, окруженный мембраной из PET-пленки с карбоновым покрытием, которая также выполняет функции подвеса. Такая комбинация обеспечивает исключительно точное натуральное звучание и идеальный тональный баланс, а с целью минимизации вибраций вся конструкция помещена в защитный миниатюрный корпус, изготовленный из титана.`},
                    {li:`Динамик обладает мощной магнитной системой на основе магнита из неодимового сплава и облегченной алюминиевой катушки с медным покрытием.`},
                    {li:`Съемный 4N OFC кабель длиной 1,2 м с разъемами  MMCX, независимой землей левого и правого каналов и позолоченным штекером 3,5мм.`},
                    {li:` Насадки Spiral Dot Plus из специального полимера  SMP iFit, имеющего механические характеристики близкие к коже человека`},
                    {li:`В комплекте: амбушюры 5 размеров (S / MS / M / ML / L), футляр  для переноски.`},
                    {li:`Сделано в Японии.`}

                ],
                srcs: [{src:"/img/img1.jpg"},{src:"/img/img12.jpg"},{src:"/img/img13.jpg"},{src:"/img/img14.jpg"},{src:"/img/img15.jpg"}],
                priceNew: "139 990 ₽",
                alt: "FW10000",
                num: 1
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw1800-f",
                className:"right",
                title: "HA-FW1800",
                text: [
                    {li:` Деревянный купол диафрагмы и мембраной из PET-пленки с карбоновым покрытием диаметром 11 мм для точного воспроизведения аудио высокого разрешения.`},
                    {li:`Эргономичная форма с надежной посадкой.`},
                    {li:`Усовершенствованный акустический очиститель.`},
                    {li:`Усовершенствованная конструкция воздушной камеры за драйвером. Дополнительные отверстия и акустическое демпфирование для более глубоких и динамичных басов.`},
                    {li:`Съемный 4N OFC кабель длиной 1,2 м с разъемами  MMCX, независимой землей левого и правого каналов и позолоченным штекером 3,5мм.`},
                    {li:`Насадки Spiral Dot Plus из специального полимера  SMP iFit, имеющего механические характеристики близкие к коже человека`},
                    {li:`В комплекте: амбушюры 5 размеров (S / MS / M / ML / L), держатель кабеля, зажим, футляр для переноски.`},
                    {li:`Сделано в Японии.`}
                ],
                priceNew: "44 990 ₽",
                srcs: [{src:"/img/img2.jpg"},{src:"/img/img22.jpg"},{src:"/img/img23.jpg"},{src:"/img/img24.jpg"},{src:"/img/img25.jpg"}],
                alt: "FW1800",
                num: 2
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw01-f",
                className:"left",
                title: "HA-FW01",
                text: [
                    {li:`11мм Мембрана с куполом из натурального дерева.`},
                    {li:`Усовершенствованная конструкция драйвера. Новая мощная магнитня система с облегченной CCAW катушкой создаёт магнитное поле с индукцией свыше 1 Тл. Эта высокоэнергетическая магнитная система значительно улучшает линейность и точность колебаний диафрагмы, обеспечивая воспроизведение звука идентичное оригинальному.`},
                    {li:`Четырёхкомпонентная акустическая структура способствует минимизации нежелательных вибраций и передачи чистого звука. Это достигается путем сочетания составных частей системы, изготовленных из легированной стали, латуни и алюминия.`},
                    {li:`Новая конструкция звуковода. Новый звуковод рассеивает звуковую волну во внутренней части наушников и воспроизводит чистый звук, снижая вероятность возникновения резонанса. При проектировании была применена оригинальная технология JVC, используемая во вкладышах «Spiral Dot». Суть технологии состоит в том, что на внутренней поверхности звуковода, в определенном порядке, наносятся сферические выступы.`},
                    {li:`Роскошный внешний вид корпуса, выполненного из натурального дерева.`},
                    {li:`Съемный OFC кабель с независимым заземлением для правого и левого каналов.`},
                    {li:`Сделано в Японии. `}
                ],
                priceNew: "19 990 ₽",
                srcs: [{src:"/img/img3.jpg"},{src:"/img/img32.jpg"},{src:"/img/img33.jpg"},{src:"/img/img34.jpg"},{src:"/img/img35.jpg"}],
                alt: "FW01",
                num: 3
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw02-f",
                className:"left",
                title: "HA-FW02",
                text: [
                    {li:`10мм Мембрана с куполом из натурального дерева.`},
                    {li:`Усовершенствованная конструкция драйвера. Новая мощная магнитня система с облегченной CCAW катушкой создаёт магнитное поле с индукцией свыше 1 Тл. Эта высокоэнергетическая магнитная система значительно улучшает линейность и точность колебаний диафрагмы, обеспечивая воспроизведение звука идентичное оригинальному.`},
                    {li:`Трёхкомпонентная акустическая структура способствует минимизации нежелательных вибраций и передачи чистого звука. Это достигается путем сочетания составных частей системы, изготовленных из силикона, латуни и алюминия.`},
                    {li:`Новая конструкция звуковода. Новый звуковод рассеивает звуковую волну во внутренней части наушников и воспроизводит чистый звук, снижая вероятность возникновения резонанса. При проектировании была применена оригинальная технология JVC, используемая во вкладышах «Spiral Dot». Суть технологии состоит в том, что на внутренней поверхности звуковода, в определенном порядке, наносятся сферические выступы.`},
                    {li:`Роскошный внешний вид корпуса, выполненного из натурального дерева.`},
                    {li:`Съемный OFC кабель с независимым заземлением для правого и левого каналов.`},
                    {li:`Сделано в Японии.`}
                ],
                priceNew: "17 990 ₽",
                srcs: [{src:"/img/img4.jpg"},{src:"/img/img42.jpg"},{src:"/img/img43.jpg"},{src:"/img/img44.jpg"},{src:"/img/img45.jpg"}],
                alt: "FW02",
                num: 4
            },
            {
                
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw03-f",
                className:"left",
                title: "HA-FW03",
                text: [
                    {li:`10мм Мембрана с куполом из натурального дерева.`},
                    {li:`Усовершенствованная конструкция драйвера. Новая мощная магнитня система с облегченной CCAW катушкой создаёт магнитное поле с индукцией свыше 1 Тл. Эта высокоэнергетическая магнитная система значительно улучшает линейность и точность колебаний диафрагмы, обеспечивая воспроизведение звука идентичное оригинальному.`},
                    {li:`Двухкомпонентная акустическая структура способствует минимизации нежелательных вибраций и передачи чистого звука. Это достигается путем сочетания составных частей системы, изготовленных из силикона, латуни и алюминия.`},
                    {li:`Новая конструкция звуковода. Новый звуковод рассеивает звуковую волну во внутренней части наушников и воспроизводит чистый звук, снижая вероятность возникновения резонанса. При проектировании была применена оригинальная технология JVC, используемая во вкладышах «Spiral Dot». Суть технологии состоит в том, что на внутренней поверхности звуковода, в определенном порядке, наносятся сферические выступы.`},
                    {li:`Роскошный внешний вид корпуса, выполненного из натурального дерева.`},
                    {li:`OFC кабель с независимым заземлением для правого и левого каналов.`},
                    {li:`Сделано в Японии. `}
                ],
                srcs: [{src:"/img/img5.jpg"},{src:"/img/img52.jpg"},{src:"/img/img53.jpg"},{src:"/img/img54.jpg"},{src:"/img/img55.jpg"}],
                priceNew: "12 990 ₽",
                alt: "FW03",
                num: 5
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw7-b-f",
                className:"left",
                title: "HA-FW7",
                text: [
                    {li:`Наушники отличаются стильным деревянным корпусом с металлическими вставками, выполненными из алюминия. Мембрана с деревянным куполом обеспечивает точное и естественное воспроизведение звука.`},
                    {li:`На поверхность амбушюр нанесены оригинальные насечки, что также улучшает звучание наушников.`},
                    {li:`Широкий диапазон воспроизведения частот (от 6 до 40 000 Гц), сравнимый с полноразмерными моделями, позволит вам в полной мере ощутить все нюансы прослушиваемого трека.`},
                    {li:`Позолоченные контакты менее подвержены окислению, обеспечивается долгий срок службы штекера даже при частом подключении и отключении наушников от источника звука.`}
                ],
                srcs: [{src:"/img/img6.jpg"},{src:"/img/img62.jpg"},{src:"/img/img63.jpg"},{src:"/img/img64.jpg"},{src:"/img/img65.jpg"}],
                priceNew: "5 490 ₽",
                alt: "FW7",
                num: 6
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fw1000t",
                className:"left",
                title: "HA-FW1000T",
                text: [
                    {li:` Первые в мире наушники True Wireless с углеродной диафрагмой и деревянным куполом.`},
                    {li:`Драйвер 11мм идентичен по своей конструкции  драйверам Hi-Res линейки JVC серии WOOD.`},
                    {li:`Фирменная технология K2 улучшает качество звука, приближая его к оригиналу.`},
                    {li:`В настройке звучания принимали участие профессионалы одной из ведущих студий звукозаписи Японии,  Victor Studio.`},
                    {li:`Новые амбушюры Spiral Dot Pro для безупречного, чистого звука. Поставляются в пяти размерах: S / MS / M / ML / L.`},
                    {li:` Гибридная система  активного шумоподавление Qualcomm® Adaptive ANC.`},
                    {li:`Поддержка Qualcomm® aptX™ Adaptive 96кГц/24бит.`},
                    {li:`100-ступенчатая регулировка громкости.`},
                    {li:`Независимое использование левого и правого наушника.`},
                    {li:`До 27 часов работы (включая зарядный кейс).`},

                ],
                srcs: [{src:"/img/img67.jpg"},{src:"/img/img672.jpg"},{src:"/img/img673.jpg"},{src:"/img/img674.jpg"},{src:"/img/img675.jpg"}],
                priceNew: "34 990 ₽",
                alt: "FW1000T",
                num: 67
            },
            {
                
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fd01-f",
                className:"right",
                title: "HA-FD01",
                text: [
                    {li:` Корпус, полностью изготовленный из легированной стали, обеспечивает живые высокие частоты и четкие басы.`},
                    {li:` Новый динамик D3 в корпусе с титановым покрытием обеспечивает надежный высококачественный звук. D3 означает «достойный, отчетливый и восхитительный» (“Dignified, Distinct, and Delightful”). Динамик выдает отчетливый в деталях звук, приятный для слуха.`},
                    {li:`Диафрагма DLC (Dome Dual Carbon) состоит из четырех различных материалов - двух высокомолекулярных полимеров и двух аморфных атомов углерода. В центре диафрагмы находится купол из полиэтиленнафталата (PEN), который представляет собой материал, обладающий большей прочностью, чем полиэтилентерефталат. Эта область купола покрыта алмазоподобной углеродной (DLC) пленкой для стабильности и прочности.`},
                    {li:`Поворотный механизм обеспечивает оптимальную посадку.`},
                    {li:`Система форсунок J-Mount позволяет настраивать звук с помощью трех типов форсунок из разных материалов, легированная сталь, латунь, титан.`},
                    {li:`Съемный рифленый кабель с MMCX разъемами имеет изолированные левым и правым каналы, что обеспечивает чистую и естественную звуковую гамму.`},
                    {li:`Наушники оснащены амбушюрами Spiral Dot Plus из нового материала для естественной посадки и повышенной выразительности звучания.`}
                ],
                srcs: [{src:"/img/img7.jpg"},{src:"/img/img72.jpg"},{src:"/img/img73.jpg"},{src:"/img/img74.jpg"},{src:"/img/img75.jpg"}],
                priceNew: "24 990 ₽",
                alt: "FD01",
                num: 7
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-fd02-f",
                className:"right",
                title: "HA-FD02",
                text: [
                    {li:`Корпус, полностью изготовленный из легированной стали, обеспечивает живые высокие частоты и четкие басы.`},
                    {li:`Новый динамик D3 в корпусе с титановым покрытием обеспечивает надежный высококачественный звук. D3 означает «достойный, отчетливый и восхитительный» (“Dignified, Distinct, and Delightful”). Динамик выдает отчетливый в деталях звук, приятный для слуха.`},
                    {li:` Диафрагма DLC (Dome Dual Carbon) состоит из четырех различных материалов - двух высокомолекулярных полимеров и двух аморфных атомов углерода. В центре диафрагмы находится купол из полиэтиленнафталата (PEN), который представляет собой материал, обладающий большей прочностью, чем полиэтилентерефталат. Эта область купола покрыта алмазоподобной углеродной (DLC) пленкой для стабильности и прочности.`},
                    {li:` Поворотный механизм обеспечивает оптимальную посадку.`},
                    {li:` Съемный рифленый кабель с MMCX разъемами имеет изолированные левым и правым каналы, что обеспечивает чистую и естественную звуковую гамму.`},
                    {li:`Наушники оснащены амбушюрами Spiral Dot Plus из нового материала для естественной посадки и повышенной выразительности звучания.`}
                ],
                priceNew: "19 990 ₽",
                srcs: [{src:"/img/img8.jpg"},{src:"/img/img82.jpg"},{src:"/img/img83.jpg"},{src:"/img/img84.jpg"},{src:"/img/img85.jpg"}],
                alt: "FD02",
                num: 8
            },
        ],
        [
            {
                id: "waybills",
                href: "https://www.pult.ru/product/naushniki-jvc-ha-sw01-f",
                h1: `(накладные)`,
                className:"left",
                title: "HA-SW01",
                text: [
                    {li:`40ММ ДРАЙВЕР С ПЭН МЕМБРАНОЙ И КУПОЛОМ ИЗ НАТУРАЛЬНОГО ДЕРЕВА`},
                    {li:`Благодаря большому опыту в области тонкопленочных материалов удалось создать ПЕН мембрану с деревянным куполом толщиной всего 50мкм.`},
                    {li:`СПЕЦИАЛЬНАЯ КОНСТРУКЦИЯ МАГНИТА`},
                    {li:`Специально для использования с новой мембраной разработано новая магнитная система, создающая поле с индукцией свыше 1 Тл.`},
                    {li:`ВЫСОКОЕ КАЧЕСТВО ЗВУКА`},
                    {li:`Качественный звук обеспечивается, в том числе, эксклюзивной технологией контроля вибрации от JVC с использованием деревянных деталей.`},
                    {li:`КОРПУС`},
                    {li:`Отделка корпуса выполнена из спрессованных деревянных пластин толщиной 1мм. Такая технология позволяет минимизировать зависимость характеристик материала от параметров внешней среды.`},
                    {li:`КОМФОРТ`},
                    {li:`Изогнутый дефлектор и комфортные амбушюры минимизируют потери при передаче звука от драйвера к уху.`},
                    {li:`ОТСОЕДИНЯЕМЫЙ ДВУСТОРОННИЙ КАБЕЛЬ`},
                    {li:`1.2м с тканевым покрытием имеет антивибрационные штекеры, независимую «землю» правого и левого каналов и изготовлен из бескислородной меди.`},
                    {li:`КОМПАКТНОСТЬ`},
                    {li:`Благодаря поворотному механизму чашек, наушники не займут много места в сумке. А мягкий чехол, идущий в комплекте поставки, сделает переноску и хранение удобными и белее безопасными.`},
                    {li:`ДЕТАЛИ ИЗ НАТУРАЛЬНОГО ДЕРЕВА`},
                    {li:`В модели HA-SW01 для улучшения качества звука кольцо дефлектора, проставки и подложка изготовлены из клена и имеют оптимальную форму. Кроме того, используется специальный припой для аудио с отличными акустическими характеристиками.`},
                ],
                srcs: [{src:"/img/img9.jpg"},{src:"/img/img92.jpg"},{src:"/img/img93.jpg"},{src:"/img/img94.jpg"},{src:"/img/img95.jpg"}],
                priceNew: "34 990 ₽",
                alt: "SW01",
                num: 9
            },
            {
                href: "https://www.pult.ru/product/naushniki-jvc-ha-sw02-f",
                className:"left",
                title: "HA-SW02",
                text: [
                    {li:`40ММ ДРАЙВЕР С ПЭН МЕМБРАНОЙ И КУПОЛОМ ИЗ НАТУРАЛЬНОГО ДЕРЕВА`},
                    {li:`Благодаря большому опыту в области тонкопленочных материалов удалось создать ПЕН мембрану с деревянным куполом толщиной всего 50мкм.`},
                    {li:`СПЕЦИАЛЬНАЯ КОНСТРУКЦИЯ МАГНИТА`},
                    {li:`Специально для использования с новой мембраной разработано новая магнитная система, создающая поле с индукцией свыше 1 Тл.`},
                    {li:`ВЫСОКОЕ КАЧЕСТВО ЗВУКА`},
                    {li:`Качественный звук обеспечивается, в том числе, эксклюзивной технологией контроля вибрации от JVC с использованием деревянных деталей.`},
                    {li:`КОРПУС`},
                    {li:`Отделка корпуса выполнена из спрессованных деревянных пластин толщиной 1мм. Такая технология позволяет минимизировать зависимость характеристик материала от параметров внешней среды.`},
                    {li:`КОМФОРТ`},
                    {li:`Изогнутый дефлектор и комфортные амбушюры минимизируют потери при передаче звука от драйвера к уху.`},
                    {li:`ОТСОЕДИНЯЕМЫЙ ДВУСТОРОННИЙ КАБЕЛЬ`},
                    {li:`1.2м с тканевым покрытием имеет антивибрационные штекеры, независимую «землю» правого и левого каналов и изготовлен из бескислородной меди.`},
                    {li:`КОМПАКТНОСТЬ`},
                    {li:`Благодаря поворотному механизму чашек, наушники не займут много места в сумке. А мягкий чехол, идущий в комплекте поставки, сделает переноску и хранение удобными и более безопасными.`},
                    
                ],
                srcs: [{src:"/img/img10.jpg"},{src:"/img/img102.jpg"},{src:"/img/img103.jpg"},{src:"/img/img104.jpg"},{src:"/img/img105.jpg"}],
                priceNew: "27 990 ₽",
                alt: "SW02",
                num: 10
            }

        ],
        [
            {       id: "Bluetooth",
                    h1: " (Bluetooth, накладные с активным шумоподавлением)",
                    href: "https://www.pult.ru/product/naushniki-jvc-ha-s91n-b-u",
                    className:"right",
                    title: "HA-S91N",
                    text: [
                        {li:`Наушники с шумоподавлением для качественного прослушивания без отвлечения на окружающий шум.`},
                        {li:`Режим Ambient Sound позволяет слышать окружающие звуки в наушниках.`},
                        {li:`Удобная, легкая конструкция с мягкими амбушюрами позволяет пользоваться наушниками в течении длительного времени.`},
                        {li:`Компактная складывающаяся в двух направлениях конструкция для удобной переноски. Чехол в комплекте.`},
                        {li:`Поддержка голосовых помощников.`},
                        {li:`Чистая передача голоса со встроенным микрофоном для разговоров.`},
                        {li:`Исключительное качество звука благодаря мощным магнитам диаметром 40 мм.`},
                        {li:`Длительное время работы: до 42 часов (BT) / 37 ч (BT + NC).`},
                        {li:`Съемный кабель.`},
                        {li:`Кабель для зарядки (USB Type-C®) в комплекте.`}
                    ],
                    priceNew: "7 490 ₽",
                    srcs: [{src:"/img/img11.jpg"},{src:"/img/img112.jpg"},{src:"/img/img113.jpg"},{src:"/img/img114.jpg"},{src:"/img/img115.jpg"}],
                    alt: "S91N",
                    num: 11
            }
        ]

    ],
    FooterList : [
        [
            {   id: "2item",
                idCol: "2Col",
                href: "https://www.pult.ru/main/akustika",
                text: "Акустика"
            },
            {
                href: "https://www.pult.ru/main/hi-fi/",
                text: "Hi-Fi"
            },
            {
                href: "https://www.pult.ru/main/vinil/",
                text: "Винил"
            },
            {
                href: "https://www.pult.ru/main/naushniki/",
                text: "Наушники"
            },
            {
                href: "https://www.pult.ru/main/televizory/",
                text: "Телевизоры"
            },
            {
                href: "https://www.pult.ru/main/proektory/",
                text: "Проекторы"
            }
        ],
        [
            {   id: "1item",
                idCol: "1Col",
                href: "https://www.pult.ru/sale/rasprodaja/",
                text: "Распродажа"
            },
            {
                href: "https://www.pult.ru/sale/rasprodaja/",
                text: "Outlet"
            },
            {
                href: "https://www.pult.ru/action/",
                text: "Акции"
            },
            {
                href: "https://www.pult.ru/skidki-i-bonusi/",
                text: "Бонусы и скидки"
            },
            {
                href: "https://www.pult.ru/oplata/pokupka-v-rassrochku",
                text: "Рассрочка"
            }
        ],
        [
            {   id: "3item",
                idCol: "3Col",
                href: "https://www.pult.ru/company/pochemu-vybirayut-pult-ru",
                text: "О компании"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Контакты"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Салоны"
            },
            {
                href: "https://www.pult.ru/news/",
                text: "Новости"
            }
        ],
    ]
}
export default state;